import { apiClientManager } from '@common/api';
export async function getFeatureFlags() {
    const r = await apiClientManager.getClient().get('/api/feature-flags');
    return r.data;
}
export async function updateFeatureFlag(id, enabled) {
    await apiClientManager.getClient().put(`/api/feature-flags/${id}`, { value: enabled });
}
